<template>
<div class='profile-income'>
  <div class='summary pane'>
    <table>
      <tr class='number'>
        <td><span v-html="priceReadableInHtml(user.total_income)"></span></td>
        <td><span v-html="priceReadableInHtml(Number(user.total_income) - Number(user.balance))"></span></td>
        <td><span v-html="priceReadableInHtml(user.balance)"></span></td>
        <td></td>
      </tr>
      <tr class='label'>
        <td>总收入</td>
        <td>已提现</td>
        <td>余额</td>
      </tr>
    </table>

    <div class='withdraws'>
      <p class='title'>
        提现记录
        <a class='text-btn' style='margin-left: 1em;' href='http://ppj.io/docs/#/feedback' target='_blank'>申请提现</a>
      </p>
      <el-table :data="withdrawData" style="width: 100%">
        <el-table-column label="时间">
          <template scope='scope'>
            <span>{{dateReadable(scope.row.created_at)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="amount" label="总额" width="180">
          <template scope='scope'>
            <span v-html="priceReadableInHtml(scope.row.amount)"></span>
          </template>
        </el-table-column>
        <el-table-column prop="payment_method" label="转出账号">
        </el-table-column>
        <el-table-column prop="state" label="状态">
        </el-table-column>
      </el-table>
    </div>
  </div>

  <div class='details pane'>
    <p class='title' v-once>{{$t('projectIncome')}}</p>
    <el-table :data="formData" style="width: 100%">
      <el-table-column prop="name" :label="$t('projectName')" width="200">
      </el-table-column>
      <el-table-column label="当前价格">
        <template scope='scope'>
          <span v-html="priceReadableInHtml(scope.row.pay_to_read_price)"></span>
        </template>
      </el-table-column>
      <el-table-column prop="view_rights_count" label="付费人数">
      </el-table-column>
      <el-table-column label="总收入">
        <template scope='scope'>
          <span v-html="priceReadableInHtml(scope.row.total_income)"></span>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template scope="scope">
          <el-button type="text" size="small">查看</el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</div>
</template>

<style lang='scss' scoped>
.profile-income {
    .pane {
        .title {
            color: $font-color-strong;
            font-size: 16px;
            margin-top: 0;
            line-height: 2em;

            a {
                font-size: $font-size-base;
            }
        }
    }

    .summary {
        .title {
            color: $font-color-strong;
        }

        table {
            width: 100%;
            td {
                width: 200px;
            }
            .number {
                font-size: $font-size-large;
            }

            .label {
                color: $font-color-strong;
                margin: 1em 0;
                line-height: 2em;
            }
        }

        .withdraws {
            margin-top: $margin-base;
            border-top: $border-base;
            padding-top: $margin-base;
        }
    }
}
</style>

<i18n>
{
  "zh-cn": {
    "projectIncome": "@:common.project收入",
    "projectName": "@:common.project名称"
  }
}
</i18n>

<script>
export default {
  data() {
    return {
      formData: [],
      withdrawData: []
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.$store.dispatch('income/index').then(res => {
        vm.formData = res.data.list
      })

      vm.$store.dispatch('withdraw/index').then(res => {
        vm.withdrawData = res.data.list
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?46d5bffe